"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_feature_flags_1 = require("owa-mail-feature-flags");
var contextProperty_1 = require("owa-service/lib/factory/contextProperty");
var findPeopleJsonRequest_1 = require("owa-service/lib/factory/findPeopleJsonRequest");
var findPeopleRequest_1 = require("owa-service/lib/factory/findPeopleRequest");
var indexedPageView_1 = require("owa-service/lib/factory/indexedPageView");
var personaResponseShape_1 = require("owa-service/lib/factory/personaResponseShape");
var propertyUri_1 = require("owa-service/lib/factory/propertyUri");
var findPeopleOperation_1 = require("owa-service/lib/operation/findPeopleOperation");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
var MAX_ENTRIES_DIRECTORY = 20;
var MAX_ENTRIES_TYPEDOWN = 10;
function configureIndexedPageView(includeDirectory) {
    return indexedPageView_1.default({
        BasePoint: 'Beginning',
        Offset: 0,
        MaxEntriesReturned: includeDirectory ? MAX_ENTRIES_DIRECTORY : MAX_ENTRIES_TYPEDOWN,
    });
}
function configureRequestBody(queryString, includeDirectory) {
    var querySources = ['Mailbox'];
    if (includeDirectory) {
        querySources.push('Directory');
    }
    return findPeopleRequest_1.default({
        IndexedPageItemView: configureIndexedPageView(includeDirectory),
        PersonaShape: configurePersonaShape(),
        QuerySources: querySources,
        QueryString: queryString,
        SearchPeopleSuggestionIndex: true,
        ShouldResolveOneOffEmailAddress: false,
        Context: configureContext(),
    });
}
function configurePersonaShape() {
    return owa_mail_feature_flags_1.isMailFeatureEnabled('rp-requestPersonaResponseShape')
        ? personaResponseShape_1.default({
            BaseShape: 'IdOnly',
            AdditionalProperties: [
                propertyUri_1.default({ FieldURI: 'PersonaEmailAddress' }),
                propertyUri_1.default({ FieldURI: 'EmailAddresses' }),
                propertyUri_1.default({ FieldURI: 'PersonaDisplayName' }),
                propertyUri_1.default({ FieldURI: 'PersonaDisplayNames' }),
                propertyUri_1.default({ FieldURI: 'PersonaId' }),
                propertyUri_1.default({ FieldURI: 'PersonaType' }),
            ],
        })
        : personaResponseShape_1.default({
            BaseShape: 'Default',
        });
}
function configureContext() {
    return [contextProperty_1.default({ Key: 'AppName', Value: 'OWA' })];
}
function findPeople(queryString, includeDirectory) {
    var requestBody = configureRequestBody(queryString, includeDirectory);
    return findPeopleOperation_1.default(findPeopleJsonRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    })).then(function (response) {
        var responseMessage = response.Body;
        return responseMessage;
    });
}
exports.findPeople = findPeople;
//# sourceMappingURL=findPeople.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-recipient-common/lib/services/findPeople.js
// module id = 2737
// module chunks = 2 3 4 45 63